"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ColorsSection_1 = tslib_1.__importDefault(require("../configurationControls/colors/ColorsSection"));
var LegendSection_1 = tslib_1.__importDefault(require("../configurationControls/legend/LegendSection"));
var internalIntlProvider_1 = require("../../utils/internalIntlProvider");
var sdk_model_1 = require("@gooddata/sdk-model");
var bucketHelper_1 = require("../../utils/bucketHelper");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var ConfigurationPanelContent = /** @class */ (function (_super) {
    tslib_1.__extends(ConfigurationPanelContent, _super);
    function ConfigurationPanelContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigurationPanelContent.prototype.render = function () {
        return (react_1.default.createElement("div", { key: "config-" + this.props.type },
            react_1.default.createElement(internalIntlProvider_1.InternalIntlWrapper, { locale: this.props.locale }, this.renderConfigurationPanel())));
    };
    ConfigurationPanelContent.prototype.isControlDisabled = function () {
        var _a = this.props, insight = _a.insight, isError = _a.isError, isLoading = _a.isLoading;
        return !insight || !sdk_model_1.insightHasMeasures(insight) || isError || isLoading;
    };
    ConfigurationPanelContent.prototype.renderColorSection = function () {
        var _a = this.props, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData, colors = _a.colors, featureFlags = _a.featureFlags, references = _a.references, insight = _a.insight, isLoading = _a.isLoading;
        var controlsDisabled = this.isControlDisabled();
        var hasMeasures = bucketHelper_1.getMeasuresFromMdObject(insight).length > 0;
        return (react_1.default.createElement(ColorsSection_1.default, { properties: properties, propertiesMeta: propertiesMeta, references: references, colors: colors, controlsDisabled: controlsDisabled, pushData: pushData, hasMeasures: hasMeasures, showCustomPicker: featureFlags.enableCustomColorPicker, isLoading: isLoading }));
    };
    ConfigurationPanelContent.prototype.renderLegendSection = function () {
        var _a = this.props, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData;
        var controlsDisabled = this.isControlDisabled();
        return (react_1.default.createElement(LegendSection_1.default, { properties: properties, propertiesMeta: propertiesMeta, controlsDisabled: controlsDisabled, pushData: pushData }));
    };
    ConfigurationPanelContent.defaultProps = {
        properties: null,
        references: null,
        propertiesMeta: null,
        colors: null,
        locale: sdk_ui_1.DefaultLocale,
        isError: false,
        isLoading: false,
        insight: null,
        pushData: noop_1.default,
        featureFlags: {},
        axis: null,
        panelConfig: {},
    };
    return ConfigurationPanelContent;
}(react_1.default.PureComponent));
exports.default = ConfigurationPanelContent;
//# sourceMappingURL=ConfigurationPanelContent.js.map